import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UserGroupInvite } from "../../../model/userGroupInvite";
import { PermissionService } from "../../../service/permission.service";
import { SnackbarService } from "../../../service/snackbar.service";

@Component({
  selector: 'app-invites-list',
  templateUrl: './invites-list.component.html',
  styleUrls: ['./invites-list.component.css']
})
export class InvitesListComponent implements OnInit, OnChanges {
  @Input() invites: UserGroupInvite[];
  completed: number = 0;

  constructor(private permissionService: PermissionService, private snackBarService: SnackbarService) { }

  ngOnInit(): void { }

  ngOnChanges(changes:SimpleChanges): void {
    if (changes.invites && !changes.invites.firstChange) {
      this.completed = this.invites.filter(invite => invite.status === 'COMPLETE').length;
    }
  }

  renewInvite(invite: UserGroupInvite) {
    invite.status = 'PENDING';
    this.permissionService.renewInvite(invite).subscribe(() => {}, error => {
      invite.status = 'EXPIRED';
      this.snackBarService.showSnackbar("Fehler beim Erneuern der Einladung!", false);
    });
  }

  deleteInvite(invite: UserGroupInvite) {
    this.permissionService.deleteInvite(invite.userGroupId, invite.id).subscribe(res => {
      this.invites = this.invites.filter(inv => inv.id != invite.id);
    }, error => {
      this.snackBarService.showSnackbar("Fehler beim Löschen der Einladung!", false);
    })
  }
}
